import React, { useState } from "react";
import WelcomeScreen from "./components/WelcomeScreen";
import Level1 from "./components/Level1";
import Level2 from "./components/Level2";
import Level3 from "./components/Level3";
import Level4 from "./components/Level4";
import Level5 from "./components/Level5";
import Level6 from "./components/Level6";
import Sidebar from "./components/Sidebar";

const animals = [
    { name: "dino", value: "dino" },
    { name: "koala", value: "koala" },
];

export default function App() {
    const [screen, setScreen] = useState<"welcome" | "level1" | "level2" | "level3" | "level4" | "level5" | "level6" | "animalSelection">("welcome");
    const [avatarImage, setAvatarImage] = useState<string>("");
    const [groupName, setGroupName] = useState<string>("");
    // Level 1
    const [level1Key, setLevel1Key] = useState(0);
    const [level1Step, setLevel1Step] = useState(0);
    // Level 2
    const [level2Key, setLevel2Key] = useState(0);
    const [level2Step, setLevel2Step] = useState(0);
    // Level 3
    const [level3Key, setLevel3Key] = useState(0);
    const [level3Step, setLevel3Step] = useState(0);
    // Level 4
    const [level4Key, setLevel4Key] = useState(0);
    const [level4Step, setLevel4Step] = useState(0);
    // Level 5
    const [level5Key, setLevel5Key] = useState(0);
    const [level5Step, setLevel5Step] = useState(0);
    // Level 6
    const [level6Key, setLevel6Key] = useState(0);
    const [level6Step, setLevel6Step] = useState(0);

    const [selectedColor, setSelectedColor] = useState<string>("gelb");
    const [selectedAnimal, setSelectedAnimal] = useState<string>("");
    const [unlockedLevels, setUnlockedLevels] = useState<Set<string>>(new Set());

    // Beispiel: State für Level und Level1-Step
    const [currentLevel, setCurrentLevel] = useState<1 | 2 | 3 | 4 | 5 | 6>(1);

    // Handler for Sidebar navigation
    const handleGoTo = (targetScreen: string) => {
        if (
            [
                "welcome",
                "level1",
                "level2",
                "level3",
                "level4",
                "level5",
                "level6",
            ].includes(targetScreen)
        ) {
            setScreen(targetScreen as typeof screen);
        }
    };

    const handleAnimalSelect = (animalValue: string) => {
        setSelectedAnimal(animalValue);
        const imagePath = `/icons/${animalValue}_${selectedColor}.png`;
        setAvatarImage(imagePath);
    };

    const handleColorSelect = (colorValue: string) => {
        setSelectedColor(colorValue);
        if (selectedAnimal) {
            const imagePath = `/icons/${selectedAnimal}_${colorValue}.png`;
            setAvatarImage(imagePath);
        }
    };

    // Wenn Level2 abgebrochen wird:
    const handleLevel2Back = () => {
        setLevel1Step(4); // Setze explizit auf Schritt 4
        setScreen("level1"); // <-- Stelle sicher, dass du auch das Screen wechselst!
    };

    const handleLevel3Back = () => {
        setLevel2Step(4); // Setze explizit auf Schritt 4 von Level2
        setScreen("level2");
    };

    const handleLevel4Back = () => {
        setLevel3Step(6); // Setze explizit auf Schritt 6 von Level3
        setScreen("level3");
    };

    const handleLevel5Back = () => {
        setLevel4Step(4); // Setze auf den letzten Schritt von Level4
        setScreen("level4");
    };

    const handleLevel6Back = () => {
        setLevel5Step(5); // Setze auf den letzten Schritt von Level5
        setScreen("level5");
    };

    // Helper to unlock a level
    const unlockLevel = (levelName: string) => {
        setUnlockedLevels(prev => new Set(prev).add(levelName));
    };

    return (
        <div style={{
            fontFamily: 'Nunito, sans-serif',
            backgroundColor: '#f0f2f5',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'row',
        }}>
            {/* Only show Sidebar if not on WelcomeScreen */}
            {screen !== "welcome" && (
                <Sidebar current={screen} goTo={handleGoTo} />
            )}
            <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px'
            }}>
                {screen === "welcome" && (
                    <WelcomeScreen
                        onStart={(avatar: string, name: string) => {
                            setAvatarImage(avatar);
                            setGroupName(name);
                            setScreen("level1");
                        }}
                    />
                )}

                {screen === "level1" && (
                    <Level1
                        key={level1Key}
                        avatarImage={avatarImage}
                        groupName={groupName}
                        onBack={() => setScreen("welcome")}
                        onNextLevel={() => setScreen("level2")}
                        onRestart={() => {
                            setLevel1Key(k => k + 1);
                            setLevel1Step(0); // <-- Reset auf ersten Step!
                        }}
                        initialLevelStep={level1Step}
                    />
                )}
                {screen === "level2" && (
                    <Level2
                        key={level2Key}
                        avatarImage={avatarImage}
                        groupName={groupName}
                        onBack={handleLevel2Back}
                        onNextLevel={() => setScreen("level3")}
                        initialLevelStep={level2Step}
                        unlocked={unlockedLevels.has("level2")}
                        unlockLevel={() => unlockLevel("level2")}
                    />
                )}
                {screen === "level3" && (
                    <Level3
                        key={level3Key}
                        avatarImage={avatarImage}
                        groupName={groupName}
                        onBack={handleLevel3Back}
                        onRestart={() => {
                            setLevel3Key(k => k + 1);
                            setLevel3Step(0); // <-- Reset auf ersten Step!
                        }}
                        onNextLevel={() => {
                            setLevel4Step(0); // <-- immer auf 0 setzen!
                            setScreen("level4");
                        }}
                        unlocked={unlockedLevels.has("level3")}
                        unlockLevel={() => unlockLevel("level3")}
                        initialLevelStep={level3Step} // <--- DAS MUSS HIER STEHEN!
                    />
                )}
                {screen === "level4" && (
                    <Level4
                        key={level4Key}
                        avatarImage={avatarImage}
                        groupName={groupName}
                        onBack={handleLevel4Back}
                        onRestart={() => {
                            setLevel4Key(k => k + 1);
                            setLevel4Step(0); // <-- Step zurücksetzen!
                        }}
                        onNextLevel={() => setScreen("level5")}
                        unlocked={unlockedLevels.has("level4")}
                        unlockLevel={() => unlockLevel("level4")}
                        initialLevelStep={level4Step} // <--- Wichtig!
                    />
                )}
                {screen === "level5" && (
                    <Level5
                        key={level5Key}
                        avatarImage={avatarImage}
                        groupName={groupName}
                        onBack={handleLevel5Back}
                        onRestart={() => {
                            setLevel5Key(k => k + 1);
                            setLevel5Step(0); // <-- Reset auf ersten Step!
                        }}
                        onNextLevel={() => setScreen("level6")}
                        unlocked={unlockedLevels.has("level5")}
                        unlockLevel={() => unlockLevel("level5")}
                        initialLevelStep={level5Step}
                    />
                )}
                {screen === "level6" && (
                    <Level6
                        key={level6Key}
                        avatarImage={avatarImage}
                        groupName={groupName}
                        onBack={handleLevel6Back} // <-- HIER!
                        onRestart={() => setLevel6Key(k => k + 1)}
                        onNextLevel={() => setScreen("level6")}
                        unlocked={unlockedLevels.has("level6")}
                        unlockLevel={() => unlockLevel("level6")}
                    />
                )}
                {screen === "animalSelection" && (
                    <div style={{ textAlign: 'center' }}>
                        <h2 style={{ marginBottom: '20px' }}>Wähle dein Tier</h2>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            gap: '20px',
                        }}>
                            {animals.map((animal) => (
                                <button
                                    key={animal.value}
                                    onClick={() => handleAnimalSelect(animal.value)}
                                    style={{
                                        backgroundColor: '#fff',
                                        border: '1px solid #ddd',
                                        borderRadius: '10px',
                                        padding: '10px',
                                        cursor: 'pointer',
                                        transition: 'transform 0.2s',
                                    }}
                                >
                                    <img
                                        src={
                                            selectedColor
                                                ? `/icons/${animal.value}_${selectedColor}.png`
                                                : `/icons/${animal.value}_gelb.png`
                                        }
                                        alt={`${animal.name} Icon`}
                                        style={{ width: 70, height: 70, marginBottom: '8px' }}
                                    />
                                    <span style={{ fontSize: '1.2em', color: '#333' }}>{animal.name}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}